module.exports = __webpack_public_path__ + "static/img/bg_forget.e8f6c91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/bg_forget.jpg
// module id = 788
// module chunks = 170